export default __webpack_public_path__ + "static/map-701a8c2dde87db37ad953d485de9e702.png";